export class TransactionHistoryEventType {

	static HISTORY = {
		TRANSACT: 'TRANSACT',
		LAST_TRANSACTIONS: 'LAST_TRANSACTIONS',
		SCHEDULED_TRANSACTIONS: 'SCHEDULED_TRANSACTIONS',
		HIDE_LAST_TRANSACTIONS: 'HIDE_LAST_TRANSACTIONS',
		HIDE_PENDING_TRANSACTIONS: 'HIDE_PENDING_TRANSACTIONS',
		HIDE_SCHEDULED_TRANSACTIONS: 'HIDE_SCHEDULED_TRANSACTIONS',
		RESUME: 'RESUME',
		BEGIN: 'BEGIN',
		TRANSACT_END: 'TRANSACT_END',
		SHOW_ALL_TRANSACTIONS: 'SHOW_ALL_TRANSACTIONS'
	};

	static ERROR = 'PAYMENT_ERROR';
	static BUTTONS = 'PAYMENT_BUTTONS';
	static BUTTONS_CONFIRM = 'BUTTONS_CONFIRM';
	static TRANSACTION_HISTORY_SEND = 'TRANSACTION_HISTORY_SEND';

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/transaction-history/transaction-history.event.type.ts